import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { pointService } from '../services/pointService'
import { useAuthStore } from '@/modules/auth/stores/authStore'

interface CreatePointPayload {
  id_client: number
  amount: number
  points: number
  transaction_type: 'add' | 'spend'
  id_branch_office: number
  comment: string
}

export function usePointMutation() {
  const navigate = useNavigate()
  const user = useAuthStore((s) => s.user)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const createPoint = async (payload: CreatePointPayload) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await pointService.create({
        ...payload,
        id_user: user?.userId ?? 0,
        id_company: user?.companyId ?? 0,
        is_valid: true,
      })
      navigate(`/clients/${payload.id_client}`)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al registrar puntos')
      } else {
        setError('Error al registrar puntos')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const invalidatePoint = async (pointId: number, clientId: number) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await pointService.invalidate(pointId)
      navigate(`/clients/${clientId}`)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al anular punto')
      } else {
        setError('Error al anular punto')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return { createPoint, invalidatePoint, isSubmitting, error }
}
